(function(angular) {
  'use strict';

      angular.module('shared')
      /**
       *
       */
          .controller('ResetPasswordCtrl', ['$scope', 'resetPasswordService', 'utilService', 'growlService', '$state', function ($scope, resetPasswordService, utilService, growlService, $state) {
        $scope.sections = [
            {
                value: "userName"
            },
            {
                value: "providePhoneCode"
            },
            {
                value: "newPassword"
            }
        ];
        $scope.currentSection = $scope.sections[0];
        $scope.resetPasswordDetails = {};
        $scope.legacyReset = utilService.buildSmsUrl("/DD/Security/Recovery/Index");  

        $scope.validatePassword = function(){
                if($scope.resetPasswordDetails.password){
                    if($scope.resetPasswordDetails.password.length>=8){
                        if($scope.resetPasswordDetails.password.toLowerCase() != $scope.resetPasswordDetails.password && $scope.resetPasswordDetails.password.toUpperCase() != $scope.resetPasswordDetails.password){
                            if($scope.resetPasswordDetails.password.match(/\d+/g) !== null){
                                if(/^[a-zA-Z0-9- ]*$/.test($scope.resetPasswordDetails.password)){
                                    $scope.passwordValidationMessage = "Password should contain at least one special char";
                                }
                                else{
                                    return false;
                                }
                            }
                            else{
                                $scope.passwordValidationMessage = "Password should contain at least one number";
                            }
                        }
                        else{
                            $scope.passwordValidationMessage = "Password should contain at least one capital and one lower case letter";
                        }
                    }
                    else{
                        $scope.passwordValidationMessage = "Password should be at least 8 characters long";
                    }
                    return true;
                }
                return false;
            };

            $scope.containOnlyNumbers = function(value){
                return /^\d+$/.test(value);
            };

            $scope.provideUserName = function(){
                resetPasswordService.startPasswordReset("mobileNumber", $scope.resetPasswordDetails.userName).then(function(result){
                    $scope.resetPasswordDetails = result;
                    $scope.currentSection = $scope.sections[1];
                    $scope.validationError = {};
                }).catch(function(error){
                    if(error.status == 404){
                        $scope.validationError = {
                            message: "Email / username not found"
                        };

                    } else if (error.status == 400 && error.statusText == "No mobile number found for the user. ") {
                        $scope.noPhoneErrorMessage = "There is no valid mobile number found for given username, please use this password recovery "
                    }
                    else{
                        growlService.danger("Unable to reset password, please contact support: "+error.statusText);
                    }

                });
            };
            $scope.providePhoneCode = function(){
                resetPasswordService.provideVerifyCode($scope.resetPasswordDetails.accountId, $scope.resetPasswordDetails.userId, $scope.resetPasswordDetails.verifyId, $scope.resetPasswordDetails.phoneCode).then(function(result){
                    result.accountId = $scope.resetPasswordDetails.accountId;
                    result.userId = $scope.resetPasswordDetails.userId;
                    $scope.resetPasswordDetails = result;
                    $scope.currentSection = $scope.sections[2];
                    $scope.validationError = {};
                }).catch(function(error){
                    if(error.status == 400 && error.data.validationFailures ){
                        for(var i in error.data.validationFailures){
                            var validationFailure = error.data.validationFailures[i];
                            if(validationFailure.paramName == "code"){
                            $scope.validationError = {
                                    message: "Invalid code, please try again"
                                };
                            }
                        }
                    }
                    else{
                        growlService.danger("There was a problem due to: "+error.statusText);
                    }
                    
                });
            };
            $scope.provideNewPassword = function(){
                resetPasswordService.completePasswordReset($scope.resetPasswordDetails.accountId, $scope.resetPasswordDetails.userId, $scope.resetPasswordDetails.passwordResetId, $scope.resetPasswordDetails.password).then(function(result){
                    growlService.success("Password successfully changed");
                    $state.go('login');
                }).catch(function(error){
                    growlService.danger("There was a problem due to: "+error.statusText);
                });
            };
           
    }]);

})(window.angular);